// src/pages/Services.tsx
import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import ServicesTable from "../components/ServicesTable";
import ServiceCategoriesTable from "../components/ServiceCategoriesTable";

const ServicesPage: React.FC = () => {
  const [tab, setTab] = useState<"services" | "categories">("services");

  return (
    <Box sx={{ flex: 1, p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Services & Categories
      </Typography>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Services" value="services" />
          <Tab label="Categories" value="categories" />
        </Tabs>
      </Paper>

      {tab === "services" && <ServicesTable />}
      {tab === "categories" && <ServiceCategoriesTable />}
    </Box>
  );
};

export default ServicesPage;
